import './Unsubscribe.css';

// Libraries
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

// Components
import Loader from 'components/Loader/Loader';

export default function Unsubscribe() {
    const [loading, setLoading] = useState(true);
    const [statusMessage, setStatusMessage] = useState('');
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get('id');

    async function optout(id) {
        return fetch(`${process.env.REACT_APP_PROXY_URL || ''}/optout`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id }),
        })
            .then((data) => {
                setLoading(false);
                if (data?.status === 200) {
                    setStatusMessage(`You've been successfully unsubscribed.`);
                } else {
                    setStatusMessage(`We were unable to unsubscribe you.`);
                }
            })
            .catch((error) => {
                setLoading(false);
                console.log({ error });
                setStatusMessage(`We were unable to unsubscribe you.`);
            });
    }

    useEffect(() => {
        if (!id) return;
        optout(id);
    }, [id]);

    return (
        <div className="unsub-wrapper">
            <div className="center-container">
                {loading ? <Loader color="dark" /> : statusMessage}
            </div>
        </div>
    );
}
